module.exports = __webpack_public_path__ + "img/planet-neptune-geology.e79d4398.png";